<!-- <div class="mainResponsive">
  <div class="Responsive"> -->

<div class="header">
    <img style="margin-top: 4px; margin-left: 80px;width: 130px;height: 70px;" src="../../../assets/images/world.jpeg"  class="logo">
    <div class="login-section" [formGroup]="loginFG">
        <div class="input-with-icon ">
      <input type="text"  formControlName="username" name="username" autocomplete="off"  placeholder="Username">
      <small  *ngIf="loginFG.controls['username'].dirty && loginFG.controls['username'].invalid" class="warn">Please enter email id!</small>
    </div>
    <div class="input-with-icon ">

      <input type="password" formControlName="password" name="password" placeholder="Password">
      <small *ngIf="loginFG.controls['password'].dirty && loginFG.controls['password'].invalid" class="warn">Please enter password!</small>
</div>
      <button mat-flat-button  (click)="login()" [disabled]="!loginFG.valid">Login</button>
     
      <div class="dropdown">
        <button  mat-flat-button class="dropbtn"  (click)="openPopup()">Reset my password?</button>
        <!-- <div class="dropdown-content">
          <a href="#">Link 1</a>
          <a href="#">Link 2</a>
          <a href="#">Link 3</a>
        </div> -->
      </div>
    </div>
  </div>
  <div style="margin-top: -25px;margin-left: 60px;color:#000F2C" class="col-md-11 d-flex justify-content-end">
   <span class="mt-3" style="font-weight: bold;">India: +91 2267719466, +91 2267719467 or Australia: +61 291592527</span>
   
    <img class="socialImg"   src="../../../assets/images/loginimg/PHONE.png"  alt="">
  </div>
  <!-- <div style="background-color: darkgray;"> -->
    <div style="margin-top: 30px;"></div>
    <div class="col-md-12" class="container-header">
      <div class="col-md-12 headers">
        <nav class="col-md-12">
          <ul class="col-md-12 row">
            <div class="col-md-8 d-flex justify-content-start">
            <li><a href="#">Home</a></li>
            <span style="color: white;font-size: 28px;">|</span>
            <li><a href="#">Services</a></li>
            <span style="color: white;font-size: 28px;">|</span>
            <li><a href="#">About Us</a></li>
            <span style="color: white;font-size: 28px;">|</span>
            <li><a href="#">Contact Us</a></li>
            
          </div>

          <div class="col-md-4 d-flex justify-content-end" style="margin-left: -30px;">
            <span >
              <img class="socialImg" src="../../../assets/images/loginimg/linkedin.png" >
         
            <img class="socialImg" src="../../../assets/images/loginimg/facebook.png" >

           <img class="socialImg" src="../../../assets/images/loginimg/instagram.png" ></span>

          </div>
         
          </ul>
        </nav>
      </div>
     </div>
  <div class="slider">
  
    <!-- <button class="prev" (click)="prevSlide()">&#10094;</button>
    <button class="next" (click)="nextSlide()">&#10095;</button> -->
    <img src="../../../assets/images/loginimg/1.gif" id="snapImage" class="active">
    <img src="../../../assets/images/loginimg/2.gif">
    <img src="../../../assets/images/loginimg/3.gif">
    <img src="../../../assets/images/loginimg/4.gif">
      
    <div class="button-container">
      <button [class.active]="currentSlide === 2" (click)="goToSlide(1)" ></button>
      <button [class.active]="currentSlide === 3" (click)="goToSlide(2)"></button>
      <button [class.active]="currentSlide === 4" (click)="goToSlide(3)"></button>
      <button [class.active]="currentSlide === 1" (click)="goToSlide(4)"></button>
    </div>
    <div class="button-containers">
      <button mat-flat-button style="background-color:#ffffff ;padding: 8px;color: #050557;height: 50px; width: 150px;" (click)="onClickRegister()" >Register with Us</button>
      <button mat-flat-button  style="background-color:rgb(230, 230, 19) ;padding: 8px;color: #050557;margin-left: 30px;height: 50px; width: 150px;" >Request Demo</button>

    </div>
  </div>
  
  <!-- <div class="slider">
  
    <img  src="../../../assets/images/loginimg/login1.gif" id="snapImage">
    <img src="../../../assets/images/loginimg/4.jpg">
    <img src="../../../assets/images/loginimg/6.jpg">
    <img src="../../../assets/images/loginimg/8.jpg">
  </div> -->
  <!-- <span *ngIF="currentSlide===1">hello</span> -->

      <!-- <img src="assets/images/Flight.png" width="100%" alt="Get it on Google Play">
    
      <div class="qr-code">
        <span>SCAN ME</span>
        <qrcode [qrdata]="qrData" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
      </div> -->
      <div class="col-md-12 pb-4 pt-4" style="background-color: #ffffff;" >
        <div class="col-md-12 row" >
     <div class="col-md-5 d-flex justify-content-center">
      <img class="col-md-12" style="height:500px ;width: 420px;" src="../../../assets/images/loginimg/WHYGILPIN.png"  alt="">
     </div>
     <div class="col-md-6 ">
      <div class="d-flex justify-content-center"><h2 class="mt-3 mb-3 bold" style="color: #040457;">WHY GILPIN?</h2>
      </div>
      <div class="d-flex justify-content-center">
    <p style="color: #000F2C;text-align: center;">Welcome to Gilpin, your trusted travel management company. With over 25 years of experience in the
      industry, we have become a leading provider of corporate travel solutions, dedicated to making your
      business trips seamless and stress-free. At Gilpin, we understand that managing corporate travel can be a
      complex and time-consuming task. That's why we offer a comprehensive range of services to help simplify
      the process, from itinerary planning and booking, to expense management and reporting. Our team of
      dedicated travel experts has extensive knowledge of the industry and a commitment to providing
      exceptional customer service</p></div>
    
     
    
     <div class="d-flex justify-content-center"><h2 class="mt-3 mb-3 bold" style="color: #040457;">CREDIBILITY</h2>
     </div>
     <div class="d-flex justify-content-center">
      <img class="col-md-12" style="height:150px ;" src="../../../assets/images/loginimg/CREDIBILITY.png"  alt="">
    
    </div>
    </div>
    </div>
    
    
    
        </div>
      <span class="containerss" >
      <div class="left-section" style="height: 380px;">
        <span class="dot">
          <img src="../../../assets/images/5.png" width="1000px" alt="Get it on Google Play">
        </span>
          <h1 >Smart Travel Starts</h1>
          <h3>with Gilpin App</h3>
    
          <h4>Download our new app</h4>
          <div class="qr-code">
            <!-- <img src="../../../assets/images/loginimg/icon/qrcode.png" [width]="130" alt=""> -->
            <qrcode [qrdata]="qrData" [width]="200" [errorCorrectionLevel]="'M'"></qrcode>
            <span >SCAN ME</span>
            <div>&nbsp;</div>
             <h1>&nbsp;</h1>
    
          </div>
    
          <div class="download-buttons">
              <a href="https://play.google.com/store" target="_blank">
                  <img src="../../../assets/images/7.png" alt="Get it on Google Play">
              </a>
             
          </div>
          <div class="download-buttonss">
          
            <a href="https://www.apple.com/app-store/" target="_blank">
                <img src="../../../assets/images/8.png" alt="Download on the App Store">
            </a>
        </div>
        <div class="download-buttonsss">
          
          <a >
            <img  src="../../../assets/images/6.png"   alt="Gilpin Travel App">
          </a>
      </div>
      <div class="download-buttonssss">
          
        <a >
          <img  src="../../../assets/images/55.png"   alt="Gilpin Travel App">
        </a>
    </div>
      </div>
    </span>
    
    <div class="col-md-12  pt-4" style="background-color: #ffffff;" >
   
   <div class="col-md-12 ">
    <div class="d-flex justify-content-center"><h2 class="mt-3 mb-3 bold" style="color: #040457;">WHY CHOOSE US</h2>
    </div>
    <div class="d-flex justify-content-center"><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>
   
    <p-carousel  [value]="chooseUsimg" [autoplayInterval]="6000"  [numVisible]="four" [numScroll]="four" circular="true" styleClass="custom-carousel"  
    >
    <!-- (mousedown)="onMouseDown($event)" #carousel (mouseup)="onMouseUp($event)" 
    (mousemove)="onMouseMove($event)" -->
      <ng-template pTemplate="item" let-us>
        <p-card  [style]="{'height': '250px','margin-top':'50px','background-color':us.color,'border-radius':'0'}">
          <div class=" col-md-12 ">
              <div class="d-flex justify-content-center">
                <img style="height:100px;" [src]="us.url" alt="Offer Image" class="offer-image" />
              </div>
             <div class="mt-4" style="color: #040457; font-family: sans-serif;text-align: center;font-size: 18px;">{{us.title}}</div>
             
             
          </div >
        </p-card>
      </ng-template>
    </p-carousel>
   
  </div>
  
  
  
      </div>

      <div class="col-md-12 pb-4" style="background-color: #ffffff;margin-top: -62px;" >
   
        <div class="col-md-12 ">
<img src="../../../assets/images/loginimg/lmbi.jpg" width="100%" alt="">
<div style="margin-top: -16.5rem;color: white ;font-weight: bold;font-size: 35px;text-align: center;">
<p >Welcome to a new era where efficiency meets innovation, all </p>
<p style="margin-top: -20px;"> encapsulated in the distinctive Gilpin experience.</p>
<button mat-flat-button style="background-color:#ffffff ;padding: 8px;color: #050557;height: 50px; width: 170px; font-size: 18px;margin-top: 1rem;" (click)="onClickRegister()" >Register with Us</button>

</div>
</div>
          </div>
<div class="world-map mt-4">
          <div class="offerings-container ">
            <!-- <h2 class="offeringstitle">OUR OFFERINGS</h2> -->
            <div class="d-flex justify-content-center "><h2 class="mt-4 mb-3 bold" style="color: #040457;">OUR OFFERINGS</h2>
            </div>
            <div class="d-flex justify-content-center mb-2"><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>

            <!-- <div class="world-map"></div> -->
            <div class="offerings-grid ">
              <div class="offering-card ">
                <img src="../../../assets/images/loginimg/icons/11.png" alt="Air Ticketing" />
                <!-- <p>Air Ticketing</p><br> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/12.png" alt="Hotel Booking" />
                <!-- <p>Hotel Booking</p><br> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/13.png" alt="Visa Management" />
                <!-- <p>Visa Management</p><br> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/14.png" alt="Forex Management" />
                <!-- <p>Forex Management</p><br> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/15.png" alt="Tour Package" />
                <!-- <p>Tour Package</p><br> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/16.png" alt="Car Rentals" />
                <!-- <p>Car Rentals</p> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/17.png" alt="Travel Insurance" />
                <!-- <p>Travel Insurance</p> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/18.png" alt="MICE Travel" />
                <!-- <p>MICE Travel</p> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/19.png" alt="Student Forex Remittance" />
                <!-- <p>Student Forex Remittance</p> -->
              </div>
              <div class="offering-card">
                <img src="../../../assets/images/loginimg/icons/20.png" alt="GST Service" />
                <!-- <p>GST Service</p> -->
              </div>
            </div>
          </div>
        </div>

        <div class="award mt-4">
          <div class="award-container ">
            <!-- <h2 class="offeringstitle">OUR OFFERINGS</h2> -->
            <div class="award-title-grid ">

            <div class="award-title-card">
              <img src="../../../assets/images/loginimg/loginIMG/multiDots.png"  />
              <!-- <p>Air Ticketing</p><br> -->
            </div>
           
            <div class="award-title-card" >
              <div class="d-flex justify-content-center mt-4 "  ><h2  class=" bold" style="color: #040457;">AWARDS</h2>
              </div>              <!-- <p>Air Ticketing</p><br> -->
              <div class="d-flex justify-content-center mb-2"  ><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>

              <!-- <p>Air Ticketing</p><br> -->
            </div>
            
            <div class="award-title-card ">
              <img src="../../../assets/images/loginimg/loginIMG/multiDots.png"  />
              <!-- <p>Air Ticketing</p><br> -->
            </div>
            </div>
            

            <!-- <div class="world-map"></div> -->
            <div class="award-grid ">
              <div class="award-card ">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/award/12.png" alt="Air Ticketing" />
                <!-- <p>Air Ticketing</p><br> -->
              </div>
              <div class="award-card">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/award/13.png" alt="Hotel Booking" />
                <!-- <p>Hotel Booking</p><br> -->
              </div>
              <div class="award-card">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/award/14.png" alt="Visa Management" />
                <!-- <p>Visa Management</p><br> -->
              </div>
              <div class="award-card">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/award/15.png" alt="Forex Management" />
                <!-- <p>Forex Management</p><br> -->
              </div>
              <div class="award-card">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/award/16.png" alt="Tour Package" />
                <!-- <p>Tour Package</p><br> -->
              </div>
              <div class="award-card">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/award/17.png" alt="Car Rentals" />
                <!-- <p>Car Rentals</p> -->
              </div>
              
            </div>
          </div>
        </div>

        <div class="testimonial-container">
          <!-- <h1 class="testimonial-header">Client Testimonial</h1> -->
          <div class="d-flex justify-content-center">

          <div class="testimonial-title-grid ">
            <div class="award-title-card">
              <img src="../../../assets/images/loginimg/loginIMG/multiDots.png"  />
              <!-- <p>Air Ticketing</p><br> -->
            </div>
           
            <div class="award-title-card" >
              <div class="d-flex justify-content-center mt-4 "  ><h2  class=" bold" style="color: #040457;">Client Testimonial</h2>
              </div>              <!-- <p>Air Ticketing</p><br> -->
              <div class="d-flex justify-content-center mb-2"  ><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>

              <!-- <p>Air Ticketing</p><br> -->
            </div>
            
            <div class="award-title-card ">
              <img src="../../../assets/images/loginimg/loginIMG/multiDots.png"  />
              <!-- <p>Air Ticketing</p><br> -->
            </div>
            </div>
            </div>
          <div class="testimonial-cards-wrapper">
            <div class="testimonial-cards">
              <!-- Card 1 -->
              <mat-card class="testimonial-card auto-hover"  *ngFor="let item of clientTestimocial" [id]="item.id" (click)="onClickChange()">
                <div class="card-content ">
                  
                  <div class="testimonial-title-grid ">
                    <div class="testimonial-coma-card "  style="margin-top: 58px;">
                      <img src="../../../assets/images/loginimg/loginIMG/landing page/19-removebg-preview.png" style="width:25px;" alt="Syrma SGS Logo" class="company-logo" />
                      </div>
                    <div class="testimonial-title-card pt-2">
                  <img [src]="item.url" alt="Syrma SGS Logo" class="company-logo" />
                  </div>
                 
                  <div class="testimonial-coma-card " style="margin-top:58px;">
                    <img src="../../../assets/images/loginimg/loginIMG/landing page/18-removebg-preview.png" style="width:25px;" alt="Syrma SGS Logo" class="company-logo" />
                    </div>
                  </div>
                  <p class="testimonial-text">
                    {{item.title}}
                  </p>
                  <div class="ratings">
                    <img src="../../../assets/images/loginimg/loginIMG/landing page/Air Ticketing (1).png" alt="Syrma SGS Logo" class="company-logo" />

                  </div>
                  <h3 class="company-name">{{item.name}}</h3>
                </div>
              </mat-card>
        
              <!-- Card 2 -->
              
            </div>
          </div>
        </div>
        <div class="accreditation-section">
          <div class="d-flex justify-content-start mt-4 "  ><h2  class=" bold" style="color: #040457;">ACCREDITATION & AFFILIATION</h2>
          </div>  
          <div class="d-flex justify-content-start mb-2"  ><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>
 
          <div class="accreditation-logos">
            <img src="../../../assets/images/loginimg/loginIMG/About us/Accreditation & Affiliation/67.png" alt="PATA" />
            <img src="../../../assets/images/loginimg/loginIMG/About us/Accreditation & Affiliation/68.png" alt="IATA" />
            <img src="../../../assets/images/loginimg/loginIMG/About us/Accreditation & Affiliation/69.png" alt="Incredible India" />
            <img src="../../../assets/images/loginimg/loginIMG/About us/Accreditation & Affiliation/70.png" alt="OTOAI" />
            <img src="../../../assets/images/loginimg/loginIMG/About us/Accreditation & Affiliation/71.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/About us/Accreditation & Affiliation/72.png"  />


          </div>
          <div class="d-flex justify-content-start mt-4 "  ><h2  class=" bold" style="color: #040457;">BRANDS WE WORK WITH</h2>
          </div>  
          <div class="d-flex justify-content-start mb-2"  ><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>
          <!-- <div class="MagicScroll" data-options="step: 0; speed: 4000;">
            <img src="example1.jpg">
            <img src="example2.jpg">
            
        </div> -->
          <div class="brands-logos">
            <div class="logos-wrapper ">

            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 1.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 2.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 3.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 4.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 5.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 6.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 7.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 8.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 9.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 10.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 11.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 12.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 13.png"  />
            <img src="../../../assets/images/loginimg/loginIMG/landing page/Brands we work with/Artboard 14.png"  />

</div>




          </div>
        </div>


        <div class="office-locations-container">
          <div class="d-flex justify-content-center mt-4 "  ><h2  class=" bold" style="color: #040457;">OUR OFFICE LOCATIONS</h2>
          </div>  
          <div class="d-flex justify-content-center mb-2"  ><span style="height:10px;width:85px ;background-color: #D9D9D9;border-radius:4px"></span></div>
 
          <div class="locations">
            <button class="location-button">MUMBAI <br /> (HEAD OFFICE)</button>
            <button class="location-button">BENGALURU</button>
            <button class="location-button">NEW-DELHI</button>
            <button class="location-button">PUNE</button>
           
          </div>
          <div class="locations">
           
            <button class="location-button">CHENNAI</button>
            <button class="location-button">CHANDIGARH</button>
            <button class="location-button">JALANDHAR</button>
            <button class="location-button">KOLKATA</button>
          </div>
        </div>
        
        <div class="address-container">
          <div  class="col-md-6">
          <h3 class="address-title">Address</h3>
          <p class="company-name">Gilpin Tours and Travel Mgt. (I) Pvt Ltd.</p>
          <p class="address">
            Corp Office: Office No. 001/002, Ground Floor, Windfall Building, Sahar Plaza Complex, J.B. Nagar, Andheri (East), Andheri, Mumbai - 400069
          </p>
        </div>
        <div class="col-md-6 d-flex justify-content-end">
          <iframe
            class="google-map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3770.115452810742!2d72.8666725!3d19.113292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c83950304023%3A0x5f9955aea15a0106!2sGilpin%20Travel%20Management(Corporate%20Travel)!5e0!3m2!1sen!2sin!4v1696457600000!5m2!1sen!2sin"
            width="600"
            height="400"
            style="border:0;"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        </div>
        <div class="contact-container">
          <div class="left-sections">
            <h1>Send Your Enquiry</h1>
            <h2>Get in Touch</h2>
            <p>Convey Your Ideas to Us</p>
            <p class="contact-description">
              Contact us for questions, technical assistance, or collaboration
              opportunities via the contact information provided.
            </p>
            <div class="contact-info">
              <a href="tel:+912267719466">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/34.png" alt="Phone" />
                +91 2267719466
              </a>
              <a href="mailto:webenquiry@gilpintravelindia.com">
                <img src="../../../assets/images/loginimg/loginIMG/landing page/35.png" alt="Email" />
                webenquiry@gilpintravelindia.com
              </a>
            </div>
          </div>
          <div class="right-sections">
            <form class="row">
              <div class="col-md-6">
              <label for="name">Name</label>
              <input type="text" id="name" placeholder="Full name" />
            </div>
            <div class="col-md-6">

              <label for="email">Email</label>
              <input type="email" id="email" placeholder="abc@xyz.com" />
        </div>
        <div class="col-md-6">

              <label for="phone">Phone Number</label>
              <input type="text" id="phone" placeholder="000 000 0000" />
        </div>
        <div class="col-md-6">

              <label for="company">Company</label>
              <input type="text" id="company" placeholder="Your Company Name" />
        </div>
        <div class="col-md-6">

              <label for="city">City</label>
              <input type="text" id="city" placeholder="Delhi" />
        </div>
        <div class="col-md-6">
              <label for="state">State</label>
              <input type="text" id="state" placeholder="India" />
</div>
<div class="col-md-12">
              <label for="message">Message</label>
              <textarea id="message" rows="4" placeholder="Enter your message"></textarea>
        </div>
              <button type="submit" class="submit-btn">Submit Now</button>
            </form>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="logo">
              <img src="../../../assets/images/world.jpeg" alt="Gilpin Travel Management Logo">
          </div>
          <nav class="footer-nav">
              <a >Home </a>  <a style="font-size: 25px;">| </a>
              <a >FAQ's </a><a style="font-size: 25px;">| </a>
              <a >Privacy Policy </a><a style="font-size: 25px;">| </a>
              <a >Contact Us</a><a style="font-size: 25px;">| </a>
              <a >Careers</a><a style="font-size: 25px;">| </a>
              <a >Terms & Conditions</a><a style="font-size: 25px;">| </a>
              <a >News & Events</a>
          </nav>
        </div>
        
        
          






  <!-- <div class="main-content">
    <h1>CORPORATE, SME, RETAIL AND AIRLINE SPECIAL FARE ON SINGLE PLATFORM.</h1>
    <button class="register">Register with Us</button>
    <button class="demo">Request Demo</button>
  </div>
  <div class="footer">
    <a href="#"><img src="assets/phone-icon.png" alt="Phone"></a>
    <a href="#"><img src="assets/youtube-icon.png" alt="YouTube"></a>
    <a href="#"><img src="assets/linkedin-icon.png" alt="LinkedIn"></a>
    <a href="#"><img src="assets/facebook-icon.png" alt="Facebook"></a>
  </div> -->
  









<nav *ngIf="false" class="navbarM col-12 row">
       
       
    <div class="menu-icon col-12 " (click)="toggleMenu()">
        
      <div class="col-12 row" >
        <div class=" col-6 pt-2" ><img src="../../../assets/images/world.jpeg" alt="" width="80px"></div>
        <div class=" col-6 d-flex justify-content-end"><mat-icon>menu</mat-icon></div>

      </div>
      
     
    </div>
   
    <ul class="menu" [ngClass]="{'show-menu': isMenuOpen}">
        <!-- <li class="d-flex justify-content-center pt-2" style=" cursor: text;"><a  >HELPLINE +91-1205110884 </a></li> -->
        <li class="d-flex justify-content-center pt-2" style=" cursor: text;"><a  > HELPLINE +91-9513399703 </a></li>

        <li class=" d-flex justify-content-center"><a style="color:#c7a7a7;cursor: text;"> WelcomeGuest!</a>
        <li class=" d-flex justify-content-center"><a routerLink="/" >HOME</a></li>
        <li class=" d-flex justify-content-center" > <a href="#"  >PRINT E-TICKET</a></li>
        <li class=" d-flex justify-content-center"><a href="#" >CONTACT US</a></li>
        <li class=" d-flex justify-content-center"><a routerLink="/corporate_login"  >CORPORATE LOGIN</a></li>
        <li class=" d-flex justify-content-center"><a routerLink="/partner_login" >PARTNER LOGIN</a></li>
    </ul>
    
</nav>  

<nav *ngIf="false" class="navbar  pl-0">

<div class="link navigation-links col-6" style="white-space: nowrap;">	
<ul >
    <li class="nav-item" style="padding-right: 40%; padding-left: -10%; cursor: text;"><a  >HELPLINE +91-9513399703 </a></li>
   
    <!-- <li class="nav-item" style="padding-right: 40%; padding-left: -10%; cursor: text;"><a  >HELPLINE +91-1205110884 </a></li> -->

    <li class="nav-item"><a style="color:#c7a7a7;cursor: text;"> WelcomeGuest!</a>
    <li class="nav-item"><a routerLink="/" style=" border-right: 1px solid rgb(199,167,167); padding-right: 5px;">HOME</a></li>
    <li class="nav-item" > <a href="#" style=" border-right: 1px solid rgb(199,167,167); padding-right: 5px;">PRINT E-TICKET</a></li>
    <li class="nav-item"><a href="#" style=" border-right: 1px solid rgb(199,167,167); padding-right: 5px;">CONTACT US</a></li>
    <li class="nav-item"><a routerLink="/corporate_login"  style=" border-right: 1px solid rgb(199,167,167); padding-right: 5px;">CORPORATE LOGIN</a></li>
    <li class="nav-item"><a routerLink="/partner_login" >PARTNER LOGIN</a></li>
</ul>

</div>
</nav>  

<div *ngIf="false" class="sign-in-page" [ngStyle]="{'background-color': PrimaryColor}" >
<div style="margin-bottom: 4%;">

</div>
<div class="topbar">
<img src="../../../assets/images/world.jpeg" alt="" >         
<!-- <img src="../../../assets/images/linux.png" alt="" width="170px" >          -->

</div>


<div class="col-12 row " >
<!--<div class="col-md-12 mb-3 row d-flex justify-content-right "  >
<div class="col-md-5 mb-2  d-flex justify-content-center" style="margin-left: 4%; border-radius:4px; color: #204083; background: rgb(221,221,221); font-weight: bold;" >
   {{loginName}}
</div>
</div>-->
<!--  <div class="col-md-12 row d-flex justify-content-center " style="max-width: 2200px; background: linear-gradient(to right, rgb(170, 205, 228), #9c9e9f ,rgb(170, 205, 228),#9c9e9f ,rgb(170, 205, 228) ,#9c9e9f,rgb(170, 205, 228)  );
">-->
<div class="col-12 row d-flex justify-content-center " style="max-width: 2200px;
">
<div *ngIf="loginName==='Welcome Partner'" class="col-md-8 pt-2 pb-2 world-wide-travel" style="padding-left: 12vh;">
    <!-- <img src="../../../assets/images/realistic-3d-detailed-world-wide-travel-concept-card-vector.jpg" alt="" width="700px" height="500px">  -->

</div>
<div class="col-md-4 sign-in-container "  >

<div class="sign-in-title-continer pt-2" >
    <span >Log into your account</span>
</div>

<div class="login mt-3 px-2 py-2">
    <form [formGroup]="loginFG" autocomplete="off" (ngSubmit)="login()">
       <!-- <mat-form-field *ngIf="loginName==='Welcome Partner'"  class="col-12 form-group">
            <div class="input-with-icon " style="padding-left: 30px; font-family:tahoma, arial; padding-top: 9px; ">
            <mat-select matInput type="text" formControlName="type">
            <mat-option value="agent">Agent</mat-option>
            <mat-option value="distributor">Distributor</mat-option>

            </mat-select>
            <mat-icon>supervisor_account</mat-icon>
        </div>
        </mat-form-field>-->
        <div class="form-group required mt-1">
            <label for="exampleInputEmail1">Email address</label>
            <div class="input-with-icon ">
            <input type="email" class="form-control" id="exampleInputEmail1" 
                    aria-describedby="emailHelp" placeholder="Enter email"
                    required
                    formControlName="username" name="username" autocomplete="off" style="padding-left: 30px; font-family:tahoma, arial; height:50px ;padding-bottom: 5px; " >
                    <mat-icon>account_circle</mat-icon>
                </div>
            <small *ngIf="loginFG.controls['username'].dirty && loginFG.controls['username'].invalid" class="warn">Please enter email id!</small>
        </div>
        <div class="form-group mt-4 required">
            <label for="exampleInputEmail1">Password</label>
            <div class="input-with-icon" >
            <input type="password" style="padding-left:30px ;height:50px; font-family:tahoma, arial; padding-bottom: 5px; " class="form-control" id="exampleInputPassword" placeholder="Password" required
                formControlName="password" name="password" autocomplete="off">
                <mat-icon>lock</mat-icon>
            </div>
                <small *ngIf="loginFG.controls['password'].dirty && loginFG.controls['password'].invalid" class="warn">Please enter password!</small>
        </div>

        <div *ngIf="invalidCredentialMsg" class="error-msg">
            <small class="warn">Invalid Username or Password!</small>
        </div>
        <div class="login-bottom-section mt-3">
            <span  (click)="openPopup()">Reset my password?</span>
         <!--   <span>Not registered user? -<a routerLink="/register-user">Register</a></span> -->
        </div>
        <div class="login-submit-container mt-4">
            <button type="submit" class="btn btn-success login-submit-btn" [disabled]="!loginFG.value.username&&!loginFG.value.password">SIGN-IN</button>
        </div>
    </form>
    <!--<div class="line mt-3"></div>
   
    <div class="line mt-3"></div>-->
</div>
</div>
<div *ngIf="loginName==='Corporate Login'" class="col-md-8 pt-2 pb-2 world-wide-travel d-flex justify-content-end" style="padding-left: 12vh;">
        <!-- <img src="../../../assets/images/realistic-3d-detailed-world-wide-travel-concept-card-vector.jpg" alt="" width="700px" height="500px">        -->
        <!-- <div class="maze-container" (keydown)="handleKey($event)" [style.width.px]="maze[0].length * 40" [style.height.px]="maze.length * 40">
            <div *ngFor="let row of maze; let rowIndex = index" class="maze-row">
              <div *ngFor="let cell of row; let colIndex = index" class="maze-cell" [ngClass]="{ 'wall': cell === 1, 'start': cell === 2, 'end': cell === 4, 'coin': cell === 3 }"></div>
              
            </div>
            <div class="player" [style.left.px]="playerPositionX * 40" [style.top.px]="playerPositionY * 40"><mat-icon>local_taxi</mat-icon></div>
          </div>
          <div>
            <p> Pickup Passengers: {{ coinsCollected }} / {{ totalCoins }}</p>
          </div> -->
          
          
        
</div>
</div>
<!--<div class="col-md-12  bottomimg">

<img src="../../../assets/images/footer_full_bg.png" alt="" >     

</div>-->
</div>
</div>
<div *ngIf="false" class="col-12 footer " >
<div class="ulink  col-6" style="white-space: nowrap;">	
<ul >
    
    <li><a href="#" style=" border-right: 1px solid #ffffff; padding-right: 5px;">CONTACT US</a></li>
    <li ><a href="#" style=" border-right: 1px solid #ffffff;  padding-right: 5px;"> ABOUT US</a></li>
    <li ><a href="#" style=" border-right: 1px solid #ffffff;  padding-right: 5px;">PAYMENT SECURITY</a></li>
    <li ><a href="#" >TERMS OF SERVICE</a></li>
</ul>

</div>
</div>

<div  class="modal" id="myMod" [style.display]="show ? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content ">
           

        <div class="modal-header">
          <h4 class="modal-title">Forgot Password</h4>
          <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
        </div>


        <div class="modal-body">
    
            <div class="form-group required">
                <label for="UserId">Enter Your User Id</label>
                <input type="text" class="form-control"  [(ngModel)]="UserId" name="UserId" autocomplete="off">
            </div>
        
      
     
        </div>
        <div class="modal-footer">
       
          <button  type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal"
          (click)="closePopup()">Close</button>
          <button  type="button" class="btn  btn-outline-success c-width-100px shadow"  data-dismiss="modal"
         (click)="sendEmail()" >Send</button>
        </div>
      </div>


